import React from "react";

const sendEmail = () => {
  var link = "mailto:berliet_hidraulicos@hotmail.com"
           + "?subject=" + encodeURIComponent("consulta")
           + "&body=" + encodeURIComponent(document.getElementById('myText').value )
  ;
  
  window.location.href = link;
}

const Contact = () => {
  return (
    <div className="contact-page-wrapper">
      <h1 className="primary-heading">Necesitas ayuda?</h1>
      <h1 className="primary-heading">Nosotros te podemos ayudar</h1>
      <div className="contact-form-container">
        <input type="text" placeholder="escribe tu email aqui" id="myText"/>
        <button className="secondary-button" onClick={(e) => sendEmail()}>Submit</button>
      </div>
    </div>
  );
};

export default Contact;
